// extracted by mini-css-extract-plugin
module.exports = {"title":"product_title__8zcRR","sub-title":"product_sub-title__Yxh4s"};